export default __webpack_public_path__ + "static/about-us-image-l4-2-f46bd7513c5c6ce13d7b00a4b5e413f6.png";